export default __webpack_public_path__ + "static/media/Design tools-cuate 1.e0e8fe17.svg";